import React from 'react';
import PropTypes from 'prop-types';
import FAQsStyles from './FAQs.styled';
import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';

const FAQs = ({ title = '', faqs = [], isAnimated = true }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <FAQsStyles
      ref={ref}
      className={`block-faqs ${isAnimated && 'isAnimated'} ${
        inView && 'active'
      }`}
    >
      <div className='inner'>
        {title && (
          <header>
            <h2>{title}</h2>
          </header>
        )}

        {faqs && faqs.length > 0 && (
          <ul className='faqs'>
            {faqs.map(({ title = '', url = '' }, i) => (
              <li className='faq' key={i}>
                <Link to={url}>{title}</Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </FAQsStyles>
  );
};

FAQs.propTypes = {
  title: PropTypes.string,
  faqs: PropTypes.array,
  isAnimated: PropTypes.bool,
};

export default FAQs;
